import * as React from "react"
import { theme } from "../theme.css"
import mainNavigation from "../staticQueries/navigation"
import v2MainMenu from "../staticQueries/v2mainmenu"
import RedAlert from "./red-alert"
import { TNavigationJson } from "../types"
import Bumbershoot from "../graphics/BUMBERSHOOT.svg"
//import BumbershootMotion from "../graphics/BUMBERSHOOT_motion.svg"
import BumbershootMotion from "../graphics/BUMBERSHOOT-animated-v1.svg"
import BumbershootLogo2025 from "../graphics/BBS2025-Horz-Wordmark-Black.svg"

import BumbershootLogoCircle from "../graphics/logo-with-circle.svg"
import { Sling as Hamburger } from 'hamburger-react'
import LineupNav from "../components/lineup-nav"

import {
  FlexList,
  NavLink,
  VisuallyHidden,
} from "./ui"
import * as styles from "./header.css"
import Badge from "./badge"

export default function Header({ className = "", customStyle={}, location }) {
 
  const shouldShowLineupNav = true;//location;// && location !== '/'; //don't show on the homepage

  const [isOpen, setOpen] = React.useState(false)
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = "visible"
    }
  }, [isOpen])

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 90);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    };
  }, []);

  let mainNavigationJson;
  let v2MainMenuJson;
  
  try {
    mainNavigationJson = JSON.parse(mainNavigation().json)
  } catch (error) {}

  try {
    v2MainMenuJson = JSON.parse(v2MainMenu().json)
  } catch (error) {}
  
  const navigation: TNavigationJson[] = mainNavigationJson
  const ticketsLink = navigation?.find(item => item.label === "Buy Tickets").link

  const v2MainMenuNav: TNavigationJson[] = v2MainMenuJson
  

  return (
    <header style={customStyle} className={`${styles.header} ${isScrolled ? styles.headerScrolled : ''}  ${className}`}>
      <RedAlert />
      <div className={styles.headerTop}>
        <div className={styles.headerLeft}>
          <div className={styles.headerCtas}>
              <NavLink to={ticketsLink} target="_blank">
                <VisuallyHidden>Sign Up</VisuallyHidden>
              <Badge
                background={theme.colors.bumberVermillion}
                textColor={theme.colors.white}
                className={`${styles.headerBadgeCircleIconSize}`}>
                  <span className={styles.headerBadge} >
                    Sign Up
                  </span>
                </Badge>
              </NavLink>
          </div>  
          <div className={styles.headerCtas}>
            <NavLink to="/donate">
              <VisuallyHidden>Donate</VisuallyHidden>
              <Badge
                background={theme.colors.bumberInk}
                textColor={theme.colors.white}
                className={`${styles.headerBadgeCircleIconSize}`}>
                <span className={styles.headerBadge}>
                  DONATE
                </span>
              </Badge>
            </NavLink>
          </div>
          <div className={styles.headerCtas}>
            <NavLink to="/festival-map">
              <VisuallyHidden>Map</VisuallyHidden>
              <Badge
                background={theme.colors.bumberSunray}
                textColor={theme.colors.black}
                className={`${styles.headerBadgeCircleIconSize}`}>
                <span className={styles.headerBadge}>
                  MAP
                </span>
              </Badge>
            </NavLink>
            {/*
            <NavLink to="https://jobs.gusto.com/boards/cannonball-arts-llc-481e128f-2454-4c6c-97dc-b99fb05b90aa" target="_blank">
              <VisuallyHidden>We're Hiring</VisuallyHidden>
              <Badge
                background={theme.colors.bumberSunray}
                textColor={theme.colors.black}
                className={`${styles.headerBadgeCircleIconSize}`}>
                <span className={styles.headerBadge} style={{textAlign: "center"}}>
                  We're <br/>Hiring!
                </span>
              </Badge>
            </NavLink>
            */}
          </div>
        </div>
        <div className={`${styles.headerCenter} ${isScrolled ? styles.headerLogoScrolled : ''}`}>
          <NavLink to="/">
            <VisuallyHidden>Home</VisuallyHidden>
            <div className={styles.headerLogo}>
              <BumbershootLogo2025 className={styles.headerLogo} />
            </div>
          </NavLink>
        </div>
        <div className={styles.headerRight}>
            <VisuallyHidden>Show Menu</VisuallyHidden>
            <div style={{zIndex:30000}}>
              <Hamburger toggled={isOpen} toggle={setOpen} label="Show menu" color={`${isOpen ? "white": theme.colors.black}`}/>
            </div>
        </div>
      </div>

      <div className={styles.mobileMenuBar}>
        <div className={styles.mobileNavTicket}>
          <NavLink to={ticketsLink} target="_blank">
            <VisuallyHidden>Sign Up</VisuallyHidden>
              <span className={styles.headerBadge}>
                Sign Up
              </span>
          </NavLink>
        </div>
        <div className={styles.mobileNavDonate}>
          <NavLink to="/donate">
            <VisuallyHidden>Donate</VisuallyHidden>
              <span className={styles.headerBadge}>
                DONATE
              </span>
          </NavLink>
        </div>
        {/*
        <div className={styles.mobileNavHiring}>
          <NavLink to="https://jobs.gusto.com/boards/cannonball-arts-llc-481e128f-2454-4c6c-97dc-b99fb05b90aa" target="_blank"> 
            <VisuallyHidden>We're Hiring!</VisuallyHidden>
              <span className={styles.headerBadge}>
                We're Hiring!
              </span>
          </NavLink>
        </div>
        */}
        <div className={styles.mobileNavFaq}>
          <NavLink to="/frequently-asked-questions/">
            <VisuallyHidden>Frequently Asked Questions</VisuallyHidden>
              <span className={styles.headerBadge}>
                FAQ
              </span>
          </NavLink>
        </div>
        <div className={styles.mobileNavAbout}>
          <NavLink to="/festival-map">
            <VisuallyHidden>Map</VisuallyHidden>
              <span className={styles.headerBadge}>
                Map
              </span>
          </NavLink>
        </div>
      </div>


      {/*
      <nav className={styles.desktopMenuBar}>
          <FlexList alignItems="start" >
            {v2MainMenuNav?.map((navItem, i: number) => (
              <li key={i}>
                <NavLink to={navItem.link} target={navItem.label === "Buy Tickets" ? "_blank" : null} className={styles.desktopNavLink}>
                  {navItem.label}
                  {navItem.blurb && (
                    <span style={{ fontSize: "0.9em", fontWeight: "400", display: "block" }}>asdf{navItem.blurb}</span>
                  )}
                </NavLink>
              </li>
            ))}
          </FlexList>
      </nav>
      */}
      {isOpen && (
        <div className={styles.mobileNavOverlay}>
          <div className={styles.mobileNavInner}>
            <nav>
              <FlexList alignItems="start" variant="column" className={styles.mobileMenuList}>
                {navigation?.map((navItem, i: number) => (
                  <li key={i}>
                    <NavLink to={navItem.link} 
                      target={navItem.label === "Buy Tickets" || navItem.label === "Accommodations" ? "_blank" : null}
                      className={styles.mobileNavLink}
                      >
                      {navItem.label}
                      {navItem.blurb && (
                        <span style={{ fontSize: "0.9em", fontWeight: "400", display: "block" }}>{navItem.blurb}</span>
                      )}
                    </NavLink>
                  </li>
                ))}
              </FlexList>
            </nav>
          </div>
        </div>
      )}
    </header>
  )
}
